import React from 'react';
import styled from 'styled-components';
import {Ellipse} from '@ey/canvascoreservices';
import {labels, currentResource} from '../../utils/utils';
import {routesResources} from '../../utils/uiconstants';
import {useCurrentProject} from '../../utils/customHooks';
import {useLocation} from 'react-router-dom';

export const ProjectSelect = () => {
	const {projectName} = useCurrentProject();

	if (projectName) {
		document.title = `${projectName} | ${labels.title}`;
	} else {
		document.title = labels.title;
	}

	const location = useLocation();

	return projectName ? (
		<StyledSection className="StyledSectionProjectName hide">
			<section className="vertical__line" />
			<h1 className="project__name">
				<Ellipse content={projectName} noOfLines={1} tooltip={projectName} />
			</h1>
		</StyledSection>
	) : location.pathname.toLowerCase().includes(`/${routesResources.admin}`) ? (
		<StyledSection className="StyledSectionAdminNavLabel hide">
			<section className="vertical__line" />
			<h1 className="project__name">
				<Ellipse content={currentResource.adminLabels.adminPortal} noOfLines={1} tooltip={currentResource.adminLabels.adminPortal} />
			</h1>
		</StyledSection>
	) : null;
};

export default ProjectSelect;

const StyledSection = styled.section`
	vertical-align: top;
	margin: var(--px-10) 0;
	display: inline-flex;
	flex-flow: row;
	max-width: calc(100% - var(--px-500));
	.vertical__line {
		height: 47%;
		margin-top: var(--px-17);
		border-left: var(--px-1) solid var(--neutrals-900);
	}
	.project__name {
		font-size: var(--px-24);
		margin: var(--px-15) var(--px-40) 0 var(--px-12);
		font-weight: 300;
		color: var(--neutrals-900);
		line-height: var(--px-24);
		overflow: auto;
	}
`;
